import classNames from 'classnames'
import { ConfirmCancelEvent, ConfirmCancelEventVariables } from 'globalTypes'
import { confirmAlert } from 'react-confirm-alert'

import { useMutation } from '@apollo/client'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faRectangleXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu } from '@headlessui/react'

import Modal from './Modal'
import MUTATION from './confirm-cancel-event.graphql'
import styles from './index.module.css'

library.add(faRectangleXmark)

interface Props {
  id: string
}

const CancelEvent = ({ id }: Props) => {
  const [mutate] = useMutation<ConfirmCancelEvent, ConfirmCancelEventVariables>(
    MUTATION
  )

  const onClick = () =>
    confirmAlert({
      closeOnClickOutside: true,
      closeOnEscape: true,
      customUI: ({ onClose }) => {
        const onConfirm = () => {
          mutate({
            variables: {
              id,
            },
          })

          onClose()
        }

        return <Modal onConfirm={onConfirm} onClose={onClose} />
      },
    })

  return (
    <Menu.Item>
      {({ active }) => (
        <button
          className={classNames(
            active ? styles.active : styles.notActive,
            styles.item
          )}
          onClick={onClick}
        >
          <FontAwesomeIcon
            className={styles.icon}
            aria-hidden="true"
            icon={['fas', 'rectangle-xmark']}
          />
          Annulla l&apos;evento
        </button>
      )}
    </Menu.Item>
  )
}

export default CancelEvent
